// extracted by mini-css-extract-plugin
export default {"container":"CartButton_container__eghzm","unset":"CartButton_unset__yOhWh","pastilleContainer":"CartButton_pastilleContainer__f3siR","label":"CartButton_label__saUBY"};